import { render, staticRenderFns } from "./AlertPago.vue?vue&type=template&id=4b60c82e&"
import script from "./AlertPago.vue?vue&type=script&lang=js&"
export * from "./AlertPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports